import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import router from "./router/index.ts";


const app = createApp(App);
app.use(router);
app.mount('#app')
router.beforeEach((to, from, next) => {
  const defaultTitle = "Tanzakademie Clemens";
  document.title = to.meta.title || defaultTitle;
  next();
});
